import { render, staticRenderFns } from "./JpNoticePopup.vue?vue&type=template&id=197da338&scoped=true&"
import script from "./JpNoticePopup.vue?vue&type=script&lang=js&"
export * from "./JpNoticePopup.vue?vue&type=script&lang=js&"
import style0 from "./JpNoticePopup.vue?vue&type=style&index=0&id=197da338&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197da338",
  null
  
)

export default component.exports